import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BarChart3, X } from 'lucide-react';
export function SlideResults() {
  const [imgError, setImgError] = useState(false);
  const [imgError2, setImgError2] = useState(false);
  const [expanded, setExpanded] = useState(false);
  return <div className="h-full w-full bg-[#EDF4F8] text-[#1B4F72] p-8 md:p-12 flex flex-col relative" data-id="element-490">
      {/* Header */}
      <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} className="mb-3" data-id="element-491">
        <div className="flex items-center gap-3 mb-1" data-id="element-492">
          <div className="w-8 h-[2px] bg-[#5B8FAF]" data-id="element-493" />
          <span className="text-[#5B8FAF] text-sm font-medium tracking-wide uppercase" data-id="element-494">
            Case Study — Roche ESMO Congress
          </span>
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-[#1B4F72] mb-1" data-id="element-495">
          Results: Main Menu & Sub Menu Overview
        </h2>
        <p className="text-[#5B8FAF] text-sm" data-id="element-496">
          Snak™ Report — Oncology ESMO Congress 6–8 December 2024
        </p>
      </motion.div>

      {/* Main image — clickable, constrained */}
      <motion.div className="flex-1 flex items-center justify-center min-h-0 cursor-pointer" initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.5,
      delay: 0.2
    }} onClick={() => setExpanded(true)} data-id="element-497">
        <div className="rounded-xl overflow-hidden shadow-lg border border-gray-200 bg-white w-full max-h-[42vh] relative group" data-id="element-498">
          {imgError ? <div className="flex flex-col items-center justify-center w-full h-64 text-gray-400" data-id="element-499">
              <BarChart3 className="w-12 h-12 mb-3 text-[#5B8FAF]/40" data-id="element-500" />
              <p className="text-sm font-medium" data-id="element-501">Image could not be loaded</p>
            </div> : <img src="https://cdn.magicpatterns.com/uploads/oAgMS44xZHe6QuwYWfvndf/Screenshot_2026-02-12_at_09.48.10.png" alt="Roche ESMO Congress — Main Menu and Sub Menu Overview" className="w-full h-full object-contain" onError={() => setImgError(true)} data-id="element-502" />}
          {/* Click hint overlay */}
          <div className="absolute inset-0 bg-[#1B4F72]/0 group-hover:bg-[#1B4F72]/5 transition-colors flex items-center justify-center" data-id="element-503">
            <span className="opacity-0 group-hover:opacity-100 transition-opacity bg-[#1B4F72] text-white text-sm font-medium px-4 py-2 rounded-full shadow-lg" data-id="element-504">
              Click to see Lung Sub Menu detail →
            </span>
          </div>
        </div>
      </motion.div>

      {/* Bottom text — now visible */}
      <motion.p className="text-center text-xs text-[#5B8FAF] mt-3 italic" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.6
    }} data-id="element-505">
        Click the image above to drill down into the Lung Sub Menu results
      </motion.p>

      {/* Expanded overlay — z-[60] to sit above persistent logos */}
      <AnimatePresence data-id="element-506">
        {expanded && <motion.div className="fixed inset-0 z-[60] bg-[#EDF4F8] flex flex-col p-8 md:p-12" initial={{
        opacity: 0,
        scale: 0.85
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.85
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 28
      }} data-id="element-507">
            {/* Close button — z-[70] to guarantee it's on top */}
            <button onClick={e => {
          e.stopPropagation();
          setExpanded(false);
        }} className="absolute top-6 right-6 z-[70] w-12 h-12 rounded-full bg-[#1B4F72] text-white flex items-center justify-center shadow-2xl hover:bg-[#5B8FAF] transition-colors" aria-label="Close detail view" data-id="element-508">
              <X className="w-6 h-6" data-id="element-509" />
            </button>

            {/* Header */}
            <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.15
        }} className="mb-4" data-id="element-510">
              <div className="flex items-center gap-3 mb-1" data-id="element-511">
                <div className="w-8 h-[2px] bg-[#5B8FAF]" data-id="element-512" />
                <span className="text-[#5B8FAF] text-sm font-medium tracking-wide uppercase" data-id="element-513">
                  Drill-Down — Lung Sub Menu
                </span>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-[#1B4F72] mb-1" data-id="element-514">
                Lung Sub Menu Overview
              </h2>
              <p className="text-[#5B8FAF] text-sm" data-id="element-515">
                Popularity #1 — 39/82 arrived at this Cue™
              </p>
            </motion.div>

            {/* Detail image */}
            <motion.div className="flex-1 flex items-center justify-center min-h-0" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.25
        }} data-id="element-516">
              <div className="rounded-xl overflow-hidden shadow-lg border border-gray-200 bg-white max-h-full w-full" data-id="element-517">
                {imgError2 ? <div className="flex flex-col items-center justify-center w-full h-64 text-gray-400" data-id="element-518">
                    <BarChart3 className="w-12 h-12 mb-3 text-[#5B8FAF]/40" data-id="element-519" />
                    <p className="text-sm font-medium" data-id="element-520">
                      Image could not be loaded
                    </p>
                  </div> : <img src="https://cdn.magicpatterns.com/uploads/8VMjxgm94CXa8uvvvpRYNe/Screenshot_2026-02-12_at_11.00.27.png" alt="Lung Sub Menu Overview — Alecensa, Tecentriq SC, Live Subcutaneous Demonstration" className="w-full h-full object-contain" onError={() => setImgError2(true)} data-id="element-521" />}
              </div>
            </motion.div>

            {/* Back hint */}
            <motion.p className="text-center text-xs text-[#5B8FAF] mt-3 italic" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.5
        }} data-id="element-522">
              Click ✕ to return to the overview
            </motion.p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}